module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921134149_T.6eb54d3f.jpg";